export default __webpack_public_path__ + "static/media/816.3ab54728.gif";